import React from "react";
import PropTypes from "prop-types";
import { stringToColor } from "../../components/CalendarCalendar/calendarHelpers";
import styles from "./DepartmentBadge.module.css";

/**
 * Chip de setor (F2.4): ponto colorido + nome do setor.
 *
 * A cor do setor (`color`) é escolhida pelo usuário em Setores (F2.3), logo
 * arbitrária — usá-la como fundo do texto arriscaria reprovar contraste WCAG.
 * Por isso o texto fica em token neutro (`--nx-muted` sobre `--nx-bg`, AA
 * garantido) e a cor entra só num ponto (swatch). Sem `color`, cai para uma cor
 * determinística pelo nome (`stringToColor`).
 */
export default function DepartmentBadge({ name, color, compact = false }) {
  if (!name) return null;
  const swatch = color || stringToColor(name);

  return (
    <span
      className={`${styles.badge} ${compact ? styles.compact : ""}`}
      title={`Setor: ${name}`}
    >
      <span
        className={styles.dot}
        style={{ background: swatch }}
        aria-hidden="true"
      />
      <span className={styles.label}>{name}</span>
    </span>
  );
}

DepartmentBadge.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string,
  compact: PropTypes.bool,
};
